import { apiCall } from './api';
import type { DiscoveredLeague } from '@sulis-liiga/common';

/**
 * Discovery service — reads the cross-tenant public endpoint
 * `GET /v1/discovery/leagues` to enumerate all leagues across all
 * operating tenants.  No auth or tenant prefix is required; the axios
 * request interceptor explicitly exempts `/v1/discovery/*` from the
 * tenant-prefix rewrite.
 */
const discoveryService = {
  /**
   * Return every league that is visible across all tenants.
   * The result carries `tenantSlug` so the UI can route subsequent
   * tenant-scoped calls to the correct operating tenant.
   */
  getLeagues: async (): Promise<DiscoveredLeague[]> => {
    return apiCall<DiscoveredLeague[]>('get', '/v1/discovery/leagues');
  },
};

export default discoveryService;
